// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"33f85df8","703":"642e163e","787":"98448cda"}[chunkId] + ".chunk.js";
};